import React, { useContext } from 'react';

import T from 'utils/useLocalizer';
import { Controller, useFormContext } from 'react-hook-form';
import { IOrderSettingsFormData } from 'models/ordersModel';
import { OrderWAPhoneEmptyContext } from './OrderWAPhoneEmptyContext';
import OrderStatusWATemplateForm from './OrderStatusWATemplateForm';

export interface Props {
  statusId: number;
  waNotificationTemplates: { id: number; name: string }[];
  isLoadingTemplates: boolean;
}
const NotifyToggle = ({ statusId, waNotificationTemplates, isLoadingTemplates }: Props) => {
  const { register, watch, setValue } = useFormContext<IOrderSettingsFormData>();
  const { onChange } = register(`systemStatuses.${statusId - 1}.isNotify`);

  const isDisabled = useContext(OrderWAPhoneEmptyContext);

  const waNotifyTemplateList = waNotificationTemplates.map((item) => ({ label: `${item.name}`, value: Number(item.id) }));
  const isNotifyEnabled = watch(`systemStatuses.${statusId - 1}.isNotify`);
  const waTemplateWatch = watch(`systemStatuses.${statusId - 1}.waTemplateId`);

  const resources = {
    NotifySwitchLabel: T('orders.order.settings.notify.switch.label'),
    notificationTemplateConstraints: T('orders.order.settings.notification.template.constraints.hint.message'),
  };

  const handleNotifyToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
    if (!e.target.checked) {
      setValue(`systemStatuses.${statusId - 1}.waTemplateId`, null);
      return;
    }

    if (waTemplateWatch && waTemplateWatch > 0) {
      setValue(`systemStatuses.${statusId - 1}.waTemplateId`, waTemplateWatch);
      return;
    }

    if (!waTemplateWatch && waNotificationTemplates.length > 0) {
      setValue(`systemStatuses.${statusId - 1}.waTemplateId`, Number(waNotificationTemplates[0].id));
    }
  };

  if (statusId === 0) {
    return null;
  }

  return (
    <div>
      <div className="form-check form-switch d-flex align-items-center gap-2 mb-3">
        <input
          {...register(`systemStatuses.${statusId - 1}.isNotify`)}
          className="form-check-input"
          type="checkbox"
          role="switch"
          style={{ width: '50px', height: '25px' }}
          disabled={isDisabled}
          onChange={(e) => handleNotifyToggleChange(e)}
        />
        <label className="form-check-label">{resources.NotifySwitchLabel}</label>
      </div>
      {isNotifyEnabled && (
        <Controller
          name={`systemStatuses.${statusId - 1}.waTemplateId`}
          render={({ field }) => (
            <OrderStatusWATemplateForm
              inputProps={field}
              toolTipId={`notification-template-hint-${statusId}`}
              waTemplateList={waNotifyTemplateList}
              isLoadingTemplateList={isLoadingTemplates}
            />
          )}
        />
      )}
    </div>
  );
};

export default NotifyToggle;
